module.exports = __webpack_public_path__ + "img/md-code-download.5845b2cd.svg";